import React from 'react';

import styled from 'styled-components';

import { Calories } from 'components/price-and-calories';
import { useFormatCalories } from 'hooks/use-format-calories';

import theme from './theme';

const SimpleWizardItemWrapper = styled.div`
  color: ${Styles.color.black};
  background-color: ${Styles.color.white};
  margin: 0 0 0.5rem 0;
  padding: 1.25rem;
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
`;

const Title = styled.h4`
  font-family: ${Styles.fontFamily.base};
  line-height: 1.1;
  margin: 0;
  text-transform: ${Styles.textTransform.headlines};
`;

const CalorieWrapper = styled.div`
  color: ${theme.caloriesColor};
  margin: 0;
`;

const Spacer = styled.div`
  margin-bottom: 2.5rem;
`;

interface ISimpleWizardItemProps {
  title: string;
  calories: number;
}

const SimpleWizardItem: React.FC<ISimpleWizardItemProps> = ({ title, calories }) => {
  const formatCalories = useFormatCalories();

  return (
    <Spacer>
      <SimpleWizardItemWrapper>
        <Title>{title}</Title>
        <Calories>
          <CalorieWrapper>{formatCalories(calories)}</CalorieWrapper>
        </Calories>
      </SimpleWizardItemWrapper>
    </Spacer>
  );
};

export default SimpleWizardItem;
